module.exports = __webpack_public_path__ + "static/media/mode-5.744330e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-5.svg
// module id = 960
// module chunks = 2